import { z } from 'zod';

/** The uploader currently supports form POSTs with no required HTTP headers. */
export const ChunkTicketResponseSchema = z.object({
  kind: z.literal('form-post'),
  url: z.string().url(),
  fields: z.record(z.string(), z.string()),
  headers: z.record(z.string(), z.never()),
  key_prefix: z.string().min(1),
  expires_at: z.string().datetime({ offset: true }),
});

export type ChunkTicketResponse = z.infer<typeof ChunkTicketResponseSchema>;

export const chunkObjectName = (index: number, format: string) =>
  `chunk_${index}.${format}`;

export const stopMarkerObjectName = () => 'stopped';

/** Mirrors the consumer's decoder; country omitted when unknown. */
export const chunkMetadataFields = (metadata: {
  startOffsetMs: number;
  durationMs: number;
  languages: string[];
  country?: string;
}): Record<string, string> => ({
  'x-amz-meta-start_offset_ms': String(metadata.startOffsetMs),
  'x-amz-meta-duration_ms': String(metadata.durationMs),
  'x-amz-meta-languages': metadata.languages.join(','),
  ...(metadata.country ? { 'x-amz-meta-country': metadata.country } : {}),
});

/** Lets the consumer detect missing chunks before finalizing. */
export const stopMarkerMetadataFields = (
  lastChunkIndex: number
): Record<string, string> => ({
  'x-amz-meta-last_chunk_index': String(lastChunkIndex),
});
